import React, { useCallback } from 'react'
import VerticalLinesThin from 'op/assets/vert-lines-thin.svg';
import VerticalLinesThick from 'op/assets/vert-lines-thick.svg';
import HorizontalLinesThin from 'op/assets/hor-lines-thin.svg';
import HorizontalLinesThick from 'op/assets/hor-lines-thick.svg';
import styled from 'styled-components';
import { Checkbox, Grid } from 'semantic-ui-react';

const OneMMVerticalLines = styled.img`
    height: 70px;
    width: 23px;
`;

const OneAndHalfMMVerticalLines = styled.img`
    height: 70px;
    width: 35px;
`;

const TwoMMVerticalLines = styled.img`
    height: 70px;
    width: 46px;
`;

const OneMMHorizontalLines = styled.img`
    height: 23px;
    width: 70px;
`;

const OneAndHalfMMHorizontalLines = styled.img`
    height: 35px;
    width: 70px;
`;

const TwoMMHorizontalLines = styled.img`
    height: 46px;
    width: 70px;
`;

const Holder = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 1em;
    justify-content: center;
    align-items: center;
`;

const LinesWithCheckbox = ({ position, onChange, label, name, children, checked }) => (
    <div style={{
        display: 'inline-flex',
        flexDirection: position === 'left' ? 'row' :
            position === 'right' ? 'row-reverse' :
                position === 'top' ? 'column' : 'column-reverse',
        width: 'fit-content',
    }}>
        <span
            style={{
                display: 'flex',
                flexDirection: position === 'left' || position === 'right' ? 'column' : 'row',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.5em',
                width: 'fit-content',
            }}
        >
            <label htmlFor={name}>{label}</label>
            <Checkbox
                name={name}
                onChange={onChange}
                checked={checked}
            />
        </span>
        {children}
    </div>
)

const CenteredGrid = styled(Grid)`
    display: flex;
    justify-content: space-around !important;
    gap: 0.5em !important;
    max-width: 380px !important;
`;

const NoPadCol = styled(Grid.Column)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
    width: 25% !important;
    gap: 0.5em !important;
`;

const Test3 = ({ view, setStpForm, id }) => {
    const onChange = useCallback((e, { name, checked }) => {
        setStpForm((prev) => {
            const newStpForm = { ...prev };

            newStpForm.data.forEach((item) => {
                if (item.STPTestView === view.STPTestView) {
                    item[name] = checked;
                }
            });

            return newStpForm;
        });
    }, [view]);

    return (
        <Holder id={id}>
            <CenteredGrid columns={3}>
                <NoPadCol>
                    <LinesWithCheckbox position='left' name={`STPTest3_1V`} label='1.0mm' onChange={onChange} checked={view.STPTest3_1V}>
                        <OneMMVerticalLines src={VerticalLinesThin} alt='Vertical lines' />
                    </LinesWithCheckbox>
                    <LinesWithCheckbox position='bottom' name={`STPTest3_1H`} label='1.0mm' onChange={onChange} checked={view.STPTest3_1H}>
                        <OneMMHorizontalLines src={HorizontalLinesThin} alt='Horizontal lines' />
                    </LinesWithCheckbox>
                </NoPadCol>
                <NoPadCol>
                    <LinesWithCheckbox position='top' name={`STPTest3_2V`} label='2.0mm' onChange={onChange} checked={view.STPTest3_2V}>
                        <TwoMMVerticalLines src={VerticalLinesThick} alt='Vertical lines' />
                    </LinesWithCheckbox>
                    <LinesWithCheckbox position='bottom' name={`STPTest3_2H`} label='2.0mm' onChange={onChange} checked={view.STPTest3_2H}>
                        <TwoMMHorizontalLines src={HorizontalLinesThick} alt='Horizontal lines' />
                    </LinesWithCheckbox>
                </NoPadCol>
                <NoPadCol>
                    <LinesWithCheckbox position='right' name={`STPTest3_15V`} label='1.5mm' onChange={onChange} checked={view.STPTest3_15V}>
                        <OneAndHalfMMVerticalLines src={VerticalLinesThin} alt='Vertical lines' />
                    </LinesWithCheckbox>
                    <LinesWithCheckbox position='bottom' name={`STPTest3_15H`} label='1.5mm' onChange={onChange} checked={view.STPTest3_15H}>
                        <OneAndHalfMMHorizontalLines src={HorizontalLinesThin} alt='Horizontal lines' />
                    </LinesWithCheckbox>
                </NoPadCol>
            </CenteredGrid>
        </Holder>
    )
}

export default Test3;
